module.exports = __webpack_public_path__ + "img/icon-right.ed69991b.svg";